import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const lockingwheelNutService = {
    getAllNuts,
    getNut,
    updateNut,
    createNut,
    updateNutStatus
};

const MODULE = {
    NUT: 'locking-wheel-nuts',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllNuts(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }
    
    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.NUT}`, requestOptions)
  }

  export function getNut(id) {   
    return apiHelper(API_URL).get(`/${MODULE.NUT}/${id}`)
  }

  export function updateNut(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).put(`/${MODULE.NUT}/${data.id}`, requestOptions)
  }

  export function createNut(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.NUT}`, requestOptions)
  }

  export function updateNutStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
    
    return apiHelper(API_URL).patch(`/${MODULE.NUT}/${data.id}`, requestOptions)
    
  }